import { LangSwitchButton, LangSwitch } from '../comp/chooseLang/ChooseLang';
import type { PageContent } from '../comp/chooseLang/ChooseLang';
import InfoBanner from '../comp/InfoBanner';
import ImageParagraph from '../comp/imgParagraph/ImageParagraph';
import './Global.css'

const pageContentPl: PageContent[] = [
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <InfoBanner title='Inzynier Informatyk' how_to='Mozna poruszac sie przy pomocy klawiszy WSAD, obracac sie przy pomocy strzalek.' />
    },
    {
        header: 'Na stronie (klinij aby przejsc):',
        type: 'pageNav',
        content: '#journey, #projekty, #zainteresowania-naukowe, #moje-narzedzia',
        custom: null
    },
    {
        header: '#journey',
        type: 'full',
        content: 'Od dziecka zadaję sobie pytania w stylu „Jak to jest zrobione?”. Teraz chcę na nie odpowiadać.\n Dzięki studiom, a nawet już przed ich rozpoczęciem, zdobyłem wiedzę z wielu różnych dziedzin. ',
        custom: null
    },
    {
        header: 'Web Design',
        type: 'sub',
        content: 'Dzięki studiom i freelancingowi zdobyłem doświadczenie w projektowaniu stron internetowych. Zaczęło się od własnoręcznie tworzonych stron, rozwinęło się w podstawy ReactJS, WordPressa, a nawet naukę programowania backendowego z użyciem narzędzi takich jak ActixWeb w Ruście. Obowiązkowe projekty na studiach pozwoliły mi poznać bazy danych takie jak MariaDB czy PostgreSQL.',
        custom: null
    },
    {
        header: 'Programowanie grafiki komputerowej',
        type: 'sub',
        content: 'W grafikę komputerową wskoczyłem po zgłębieniu podstawowych algorytmów raycastingu wyświetlanych w zwykłej konsoli tekstowej. Moją pierwszą próbą profesjonalnego API był DirectX 12. Kontynuowałem naukę poprzez OpenGL, a wszystko to zwieńczyła moja praca inżynierska zbudowana z wykorzystaniem API Vulkan. Przez cały ten czas nieodłącznym towarzyszem był C++14.',
        custom: null
    },
    {
        header: '',
        type: 'spacer',
        content: '',
        custom: null
    },
    {
        header: '#projekty',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='B3 Game Engine'
            Paragrahps={<a>Silnik gry w C++ i Vulkanie, stworzony jako moja praca inżynierska. Ma własny raytracing na wokselach działający w compute shaderze oraz wieloplatformową warstwę okien.</a>}
            Img='/b3-promo.gif'
            Type=''
            MaxHeight={500} />
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='Aplikacja zarządzająca magazynem'
            Paragrahps={<a>Aplikacja w Javie i Swingu, stworzona na zaliczenie przedmiotu. Klasy produktów są obsługiwane przez refleksję, a interfejs jest generowany dynamicznie na ich podstawie.</a>}
            Img='/jv-promo.png'
            Type='alt'
            MaxHeight={360} />
    },
    {
        header: '#zainteresowania-naukowe',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: '',
        type: 'grid',
        content: 'API systemowe, Współbieżność, Cache, Optymalizacja kodu, API graficzne, API GPU, Synchronizacja, Metaprogramowanie, Design API, Algorytmy',
        custom: null
    },
    {
        header: '#moje-narzedzia',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: 'bg-alt',
        type: 'grid',
        content: 'C++14, C++20, Vulkan API, GLSL/HLSL, CMake, OS API (Win32 and Linux), Git, Bash scripting, GDB, Valgrind, JavaScript/TypeScript, C#, Java, SQL',
        custom: null
    },
    {
        header: '',
        type: 'sub',
        content: 'Ta lista przedstawia główne narzędzia, których używam podczas mojej uniwersyteckiej/rekreacyjnej pracy programistycznej. ',
        custom: null
    },
];
const pageContentEn: PageContent[] = [
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <InfoBanner
            title='Computer Science Engineer'
            how_to='Use WSAD to move. You can rotate camera with arrow keys.' />
    },
    {
        header: 'On this site (click to scroll):',
        type: 'pageNav',
        content: '#journey, #projects, #research-interests, #my-tools',
        custom: null
    },
    {
        header: '#journey',
        type: 'full',
        content: 'I’ve been asking questions like “How can it be done?” since I was little. Now I want to answer them.\n Through college, and even before starting it, I’ve built knowledge across a wide range of topics. ',
        custom: null
    },
    {
        header: 'Web Design',
        type: 'sub',
        content: 'Thanks to college and freelancing I gained experience in website design. It started with self-created pages, grew into the basics of ReactJS, WordPress and even learning about backend programming with tools like ActixWeb with Rust. Necessary college assignments let me learn about databases like MariaDB or PostgreSQL.',
        custom: null
    },
    {
        header: 'Computer Graphics programming',
        type: 'sub',
        content: 'Jumped into computer graphics after studying basic raycasting algorithms in plain command line output. My first attempt at professional API was DirectX 12. I continued through OpenGL, and it all culminated in my engineering thesis built with the Vulkan API. Throughout all of it, C++14 has been a constant companion.',
        custom: null
    },
    {
        header: '',
        type: 'spacer',
        content: '',
        custom: null
    },
    {
        header: '#projects',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='B3 Game Engine'
            Paragrahps={<a>A game engine in C++ and Vulkan, made as my BEng thesis. It features a custom voxel ray tracer running in a compute shader and a cross-platform window layer.</a>}
            Img='/b3-promo.gif'
            Type=''
            MaxHeight={500} />
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='Java Warehouse Management Application'
            Paragrahps={<a>A Java Swing app made for a class assignment. Product classes are handled through reflection, and the GUI is generated dynamically from them.</a>}
            Img='/jv-promo.png'
            Type='alt'
            MaxHeight={360} />
    },
    {
        header: '#research-interests',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: '',
        type: 'grid',
        content: 'Operating systems APIs, Concurrency, Cache friendliness, Code optimization, Graphics APIs, GPU computation APIs, Synchronization, Metaprogramming, API design, Algorithms',
        custom: null
    },
    {
        header: '#my-tools',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: 'bg-alt',
        type: 'grid',
        content: 'C++14, C++20, Vulkan API, GLSL/HLSL, CMake, OS API (Win32 and Linux), Git, Bash scripting, GDB, Valgrind, JavaScript/TypeScript, C#, Java, SQL',
        custom: null
    },
    {
        header: '',
        type: 'sub',
        content: 'This list represents main tools that I use in my university/recreational programming time. ',
        custom: null
    },
];

function Homepage() {
    var m = new Map<string, PageContent[]>();
    m.set('en', pageContentEn);
    m.set('pl', pageContentPl);


    return (
        <>
            <LangSwitch LangMap={m} />
        </>
    );
};

export default Homepage;
